import React, { useEffect, useState, useContext } from 'react'
import '../css/sb-admin-2.min.css'
import '../css/sb-admin-2.css'

import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import $ from 'jquery';
import { AppColors } from '../css/AppColors';

import { Context } from '../Context/DataContext';
import { apiRequest } from '../utils/apiCalls';
import { Modal, Button, Form } from 'react-bootstrap'
import { useHistory, useLocation } from 'react-router-dom';

import { FaClipboardList, FaPencilAlt, FaTrash } from 'react-icons/fa'

const useForceUpdate = () => {
    const [, updateState] = React.useState();
    return React.useCallback(() => updateState({}), []);
}


const EditOrder = () => {

    const forceUpdate = useForceUpdate();

    const location = useLocation();
    const history = useHistory();

    const [loading, setLoading] = useState(false)
    const { state, setCustomersGlobal, setStoreData } = useContext(Context)

    const [customers, setCustomers] = useState(state.customers ? state.customers : [])

    const [cust_id, setCust_id] = useState(location?.state?.cust_id)
    const [products, setProd] = useState([]);
    const [presc, setPresc] = useState({});

    const [promotions, setPromotions] = useState([]);

    const [promotionsApply, setPromotionsApply] = useState('');
    const [orderQty, setOrderQty] = useState('');
    const [orderPrice, setOrderPrice] = useState('');
    const [prodPrice, setProdPrice] = useState('') //MSRP
    const [promDiscount, setPromDiscount] = useState('');

    const [delId, setDelId] = useState('')
    const [delModal, setDelModal] = useState(false)




    const [o_amount, setO_amount] = useState('');

    const [oi_items, setOi_items] = useState([{

        p_id: '', //product id
        oi_prod: '', // product name
        oi_odos: '',
        oi_sph: '',
        oi_cyl: '',
        oi_axis: '',
        oi_prism: '',
        oi_fi: '',
        oi_ct: '',
        oi_discount: '',
        oi_expiry: '', // product expiry
        oi_unit_price: '', // MSRP
        oi_qty: '', // order item quantity
        oi_amount: '', // order item net price,
        promotions: [],
        oi_prom_id: '',
        oi_prom_name: '',

        prom_apply: false, //onlye used in interface
        prom_name: '',
        prod_prom: [], // only used in interface
        prom_discount: '',// only used interface

    }])






    function getCustomers() {

        setLoading(true)
        var st_id;
        st_id = state.storeData.st_id

        apiRequest({ st_id: st_id }, 'viewcustomers')
            .then(data => {
                setLoading(false)
                if (data.status == 1) {
                    setCustomers(data.data)
                    setCustomersGlobal(data.data)
                }

            })
            .catch(err => {
                setLoading(false)
                // console.log(err)
            })
    }

    function getProducts(index) {

        setLoading(true)
        apiRequest({ st_id: state.storeData.st_id }, 'viewprod')
            .then(data => {

                if (data.status == '1') {
                    setProd(data.data)
                    setLoading(false)
                }
                else {
                    alert(data.error)
                    setLoading(false)
                }
            })
            .catch(err => {
                setLoading(false)
                alert('Network error')
                console.log(err)
            })
    }

    function getProdPromotions(p_id, index) {
        setLoading(true)
        apiRequest({ p_id, active: true }, 'viewPromotions')
            .then(data => {
                setLoading(false)
                if (data.status == '1') {
                    // 
                    console.log('promotions are')
                    console.log(data)
                    let arr = oi_items;
                    arr[index].promotions = data.data
                    setOi_items(arr);
                    arr[index].oi_qty = ''

                    forceUpdate();
                    // setPromotions(data.data)
                }
                else {
                    // alert(data.error);
                    let arr = oi_items;
                    // arr[index].prod_prom = []
                    arr[index].promotions = []
                    arr[index].prom_apply = false
                    arr[index].oi_prom_id = ''
                    arr[index].oi_prom_name = ''
                    arr[index].oi_amount = ''

                    arr[index].oi_qty = '';
                    arr[index].prom_discount = '0';


                    setOi_items(arr);
                    forceUpdate();


                    // setOrderPrice('');
                    // setOrderQty('');
                    // setPromotionsApply(false);
                    // setPromotions([]);
                }
            })
            .catch(err => {
                setLoading(false)
            })
    }

    function getOrderTotal() {

        var sum = 0;
        for (let key in oi_items) {
            if (oi_items[key].oi_amount) {
                sum += parseInt(oi_items[key].oi_amount)
            }

        }
        return sum

    }

    function validateOrder() {



        for (let i = 0; i < oi_items.length; i++) {
            if (oi_items[i].p_id.length < 1) return alert(`please select product in order item ${i + 1}`);
            if (oi_items[i].oi_odos.length < 1) return alert(`please select product od_os in order item ${i + 1} `);
            if (oi_items[i].oi_qty.length < 1) return alert(`please enter product order quantity in order item ${i + 1}`);
            if (oi_items[i].oi_amount.length < 1) return alert(`please enter order net price in order item ${i + 1}`);
        }
        addOrder()

    }

    function addOrder() {
        setLoading(true)
        var o_item = {};
        var o_itemArr = [];
        var tempOiItems
        for (let i = 0; i < oi_items.length; i++) {
            tempOiItems = oi_items[i];
            for (let key in oi_items[i]) {
                if (key == 'prom_apply' || key == 'prom_name' || key == 'prod_prom' || key == 'prom_discount') { }
                else {
                    o_item[key] = tempOiItems[key]
                }
            }
            o_itemArr[i] = o_item;
            o_item = {}
        }
        // console.log('oi_items are')
        // conole.log(oi_items)

        const reqObj = {
            o_id: location?.state?.o_id,
            o_amount: getOrderTotal(),
            o_items: o_itemArr

        }
        console.log('my final object is')
        console.log(reqObj)
        apiRequest(reqObj, 'editOrder')
            .then(data => {
                setLoading(false)
                console.log('edit order data')
                console.log(data)
                if (data.status == '1') {
                    // alert(data.msg)
                    history.push('viewOrder',{
                        cust_id : cust_id
                    })
                }
                else alert(data.error)
                // console.log(data)
            })
            .catch(err=>{
                setLoading(false)
            })
    }

    function formatOrderExpiry(numOfDays) {

        var dateObj = new Date();
        if (dateObj.getMonth() < 10) {
            const month = "0" + dateObj.getMonth();
            if (dateObj.getDate() < 10) {
                let dat = "0" + dateObj.getDate();
                dat = parseInt(dat) + parseInt(numOfDays)
                let date = dateObj.getFullYear() + "-" + month + "-" + dat;
                return date
                // props.onValueChange(date);
            }
            else {
                let dat = dateObj.getDate();
                dat = parseInt(dat) + parseInt(numOfDays)
                let date = dateObj.getFullYear() + "-" + month + "-" + dat
                return date
                // props.onValueChange(date);
            }
        }
        else {
            if (dateObj.getDate() < 10) {
                let dat = "0" + dateObj.getDate();
                dat = parseInt(dat) + parseInt(numOfDays)
                let date = dateObj.getFullYear() + "-" + dateObj.getMonth() + "-" + dat
                return date
                // props.onValueChange(date);
            }
            else {
                let dat = dateObj.getDate();
                dat = parseInt(dat) + parseInt(numOfDays)
                let date = dateObj.getFullYear() + "-" + dateObj.getMonth() + "-" + dat
                return date
                // props.onValueChange(date);
            }

        }
    }

    function getOrderItems() {

        // console.log('location')
        // console.log(location.state)


        setLoading(true)
        apiRequest({ o_id: location.state.o_id }, 'viewOrderById')
            .then(data => {
                console.log('orderItem data')
                console.log(data)
                if (data.status == '1') {
                    setOi_items(data.data)
                    setLoading(false)
                }
                else {
                    alert(data.error)
                    console.error(data.error)
                    setLoading(false)
                }
            })
            .catch(err => {
                setLoading(false);
                console.error(err)
                alert('Internet error');
            })
    }

    function delOrderItem() {
        const reqObj = {
            oi_id: delId,
            o_id: location?.state?.o_id
        }
        console.log(reqObj)
        setLoading(true)
        apiRequest(reqObj, 'delOrderItem')
            .then(data => {
                console.log(data)
                if (data.status == '1') {
                    if (data.data) {
                        setLoading(false)
                        setOi_items(data.data)
                        // alert(data.msg)
                    }
                    else {
                        getOrderItems()
                        // alert(data.msg)
                    }
                }
                else {
                    setLoading(false)
                    alert(data.error)
                }
            })
            .catch(err => {
                setLoading(false)
                alert('Internet Error')
            })




    }

    function foundSelectedProducts(p_id) {

        var item = oi_items.filter(id =>
            id.p_id == p_id ? true : false
        )
        if (item.length) return true
        else return false
    }





    useEffect(() => {

        console.log('oi_items');
        console.log(oi_items);
        if (!location?.state?.cust_id) {
            history.push('addOrder')
            return
        }


        getOrderItems()
        if (!state.customers.length) {
            getCustomers()
        }
        getProducts();


    }, [])

    useEffect(() => {
        $(document).ready(function () {
            $('#dataTable').DataTable({ searching: false, paging: false, info: false });
        });

    }, [])


    const ViewPresc = () => (
        <div>
            <div class="row mt-2 mb-3 ">
                <h4 style={{ color: 'grey' }} >OD</h4>
                <div className="col-sm-2 col-md-3 col-lg-2">
                    <div className="editDetails" >Sph</div>
                    <Form.Control
                        value={presc.odsph}
                        className="col-sm-7 mt-2"
                        placeholder={presc.odsph}
                        disabled={true}
                    />
                </div>
                <div className="col-sm-2 col-md-3 col-lg-2">
                    <div className="editDetails" >Cyl</div>
                    <Form.Control
                        value={presc.odcyl}
                        className="col-sm-7"
                        placeholder={presc.odcyl}
                        disabled={true}
                    />
                </div>
                <div className="col-sm-2 col-md-3 col-lg-2">
                    <div className="editDetails " >Axis</div>
                    <Form.Control
                        value={presc.odaxis}
                        className="col-sm-7"
                        placeholder={presc.odaxis}
                        disabled={true}
                    />
                </div>
                <div className="col-sm-2 col-md-3 col-lg-2">
                    <div className="editDetails" >Prism</div>
                    <Form.Control
                        value={presc.odprism}
                        className="col-sm-7"
                        placeholder={presc.odprism}
                        disabled={true}
                    />
                </div>
                <div className="col-sm-2 col-md-3 col-lg-2">
                    <div className="editDetails" >Fi</div>
                    <Form.Control
                        value={presc.odfi}
                        className="col-sm-7"
                        placeholder={presc.odfi}
                        disabled={true}
                    />
                </div>
                <div className="col-sm-2 col-md-3 col-lg-2">
                    <div className="editDetails" >Ct</div>
                    <Form.Control
                        value={presc.odct}
                        className="col-sm-7"
                        placeholder={presc.odct}
                        disabled={true}
                    />
                </div>
            </div>
            <div class="row mt-2 mb-3 ">
                <h4 style={{ color: 'grey' }} >OS</h4>

                <div className="col-sm-2 col-md-3 col-lg-2">
                    <div className="editDetails" >Sph</div>
                    <Form.Control
                        value={presc.ossph}
                        className="col-sm-7 mt-2"
                        placeholder={presc.ossph}
                        disabled={true}
                    />
                </div>
                <div className="col-sm-2 col-md-3 col-lg-2">
                    <div className="editDetails" >Cyl</div>
                    <Form.Control
                        value={presc.oscyl}
                        className="col-sm-7"
                        placeholder={presc.oscyl}
                        disabled={true}
                    />
                </div>
                <div className="col-sm-2 col-md-3 col-lg-2">
                    <div className="editDetails " >Axis</div>
                    <Form.Control
                        value={presc.osaxis}
                        className="col-sm-7"
                        placeholder={presc.osaxis}
                        disabled={true}
                    />
                </div>
                <div className="col-sm-2 col-md-3 col-lg-2">
                    <div className="editDetails" >Prism</div>
                    <Form.Control
                        value={presc.osaxis}
                        className="col-sm-7"
                        placeholder={presc.osaxis}
                        disabled={true}
                    />
                </div>
                <div className="col-sm-2 col-md-3 col-lg-2">
                    <div className="editDetails" >Fi</div>
                    <Form.Control
                        value={presc.osfi}
                        className="col-sm-7"
                        placeholder={presc.osfi}
                        disabled={true}
                    />
                </div>
                <div className="col-sm-2 col-md-3 col-lg-2">
                    <div className="editDetails" >Ct</div>
                    <Form.Control
                        value={presc.osct}
                        className="col-sm-7"
                        placeholder={presc.osct}
                        disabled={true}
                    />
                </div>



            </div>
        </div>
    )


    return (
        <div id="page-top">

            <div id="wrapper" >
                <Sidebar />
                <div id="content-wrapper" class="d-flex flex-column">
                    <div id="content">
                        <Topbar />


                        <div className="container-fluid" >


                            <Modal
                                show={delModal}
                                onHide={() => setDelModal(false)}
                            >
                                <Modal.Header>
                                    <Modal.Title style={{ fontSize: 18, textAlign: 'center', alignSelf: 'center', fontFamily: 'PSBo' }} >Are you sure you want to delete this order item?</Modal.Title>
                                </Modal.Header>
                                <Modal.Footer>
                                    <Button
                                        style={{ fontFamily: 'PMe' }}
                                        variant="secondary" onClick={() => {
                                            setDelId('')
                                            setDelModal(false)
                                        }}>No</Button>
                                    <Button
                                        style={{ fontFamily: 'PMe' }}
                                        variant="danger" onClick={() => {
                                            setDelModal(false)
                                            delOrderItem()
                                        }}>Yes</Button>
                                </Modal.Footer>


                            </Modal>
                            <Modal

                                show={loading}
                                onHide={() => setLoading(false)}
                            >

                                <Modal.Body class="text-center" >
                                    <div
                                        class="text-center"
                                        class="spinner-border text-center" style={{ margin: 10, color: AppColors.primary }} role="status"></div>
                                </Modal.Body>

                            </Modal>

                            {/* Page Heading */}
                            <div style={{ width: "100%", height: 65 }}>
                                <div style={{ float: "left", width: "50%" }}>
                                    <h1 className="h3 mb-2 text-gray-800">Edit Order</h1>
                                    <br />
                                </div>
                            </div>
                            <div class="tRow mb-2 " >Order No : {location?.state?.o_id}</div>
                            <div>
                                <select
                                    name="cust_id"
                                    id="cust_id"
                                    className="form-control form-control-user"
                                    disabled={true}
                                >
                                    <option selected disabled>
                                        {location?.state?.cust_fname} {location?.state?.cust_lname}
                                    </option>

                                </select>
                            </div>



                            {
                                Object.keys(presc).length ?
                                    <ViewPresc />
                                    : null
                            }

                            {/* DataTales Example */}
                            <div className="card shadow mb-4 mt-3">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div style={{ float: "left", height: 30 }}>
                                            <h1 className="h5 mb-2 text-gray-800" style={{ fontFamily: 'PMe' }} >Order Items</h1>
                                            <br />
                                        </div>
                                        <div style={{ float: "right" }}>
                                            <Button
                                                onClick={() => {
                                                    $(document).ready(function () {
                                                        var counter = 2;

                                                        $('#addRow').on('click', function () {
                                                            $("#row" + counter).show();
                                                            counter++;
                                                        });
                                                    })
                                                }}
                                                // type="button" id="addRow" defaultValue="+ Add more " 
                                                onClick={() => {
                                                    // setDataTableRows([...dataTableRows, dataTableRows + 1])
                                                    setOi_items(oi_items => [...oi_items, {
                                                        oi_id: null,
                                                        o_id: location?.state?.o_id,
                                                        p_id: '', //product id
                                                        oi_prod: '', // product name
                                                        oi_odos: '',
                                                        oi_sph: oi_items[0].oi_sph,
                                                        oi_cyl: oi_items[0].oi_cyl,
                                                        oi_axis: oi_items[0].oi_axis,
                                                        oi_prism: oi_items[0].oi_prism,
                                                        oi_fi: oi_items[0].oi_fi,
                                                        oi_ct: oi_items[0].oi_ct,
                                                        oi_expiry: '', // product expiry
                                                        oi_unit_price: '', // MSRP
                                                        oi_qty: '', // order item quantity
                                                        oi_amount: '', // order item net price,
                                                        prod_prom: []
                                                    }])
                                                    console.log(oi_items[0])
                                                }}
                                                style={{ backgroundColor: AppColors.primary, color: 'white', borderColor: AppColors.primary, marginBottom: 10, fontFamily: 'PMe' }} >
                                                Add More
                                            </Button>
                                            <br />
                                        </div>
                                        <div style={{ clear: "both" }} />
                                        {/*<table class="table table-bordered dt-responsive" id="dataTable" width="100%" cellspacing="0">*/}
                                        <table
                                            className="table table-striped table-bordered dt-responsive"
                                            id="dataTable"
                                            style={{ width: "100%", borderBottomColor: '#f3f3f3' }}
                                        >
                                            <thead>
                                                <tr>
                                                    <th className="tRow">Product</th>
                                                    <th className="tRow">Promotion</th>
                                                    <th className="tRow">Add Promotion</th>
                                                    <th className="tRow">OD/OS</th>
                                                    {/* <th className="tRow" style={{}}>SPH</th>
                                                    <th className="tRow">CYL</th>
                                                    <th className="tRow">AXIS</th>
                                                    <th className="tRow">BC</th>
                                                    <th className="tRow">DIA</th>
                                                    <th className="tRow">PKTS</th> */}
                                                    <th className="tRow">MSRP</th>
                                                    <th className="tRow">QTY</th>
                                                    <th className="tRow">Price</th>
                                                    <th className="tRow">Discount</th>
                                                    <th className="tRow">Net Price</th>
                                                    {
                                                        oi_items.length > 1 ?
                                                            <th className="tRow">Action</th>
                                                            : null
                                                    }

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {/* {
                                                Object.keys(oi_items).map(function (keyName, i) {
                                                    return <DataTableRowsView item={i} />
                                                })
                                            } */}

                                                {
                                                    oi_items.map((item, index) => {
                                                        // console.log('prom id' + index)
                                                        // console.log(item.oi_prom_id)
                                                        return (
                                                            <tr>
                                                                <td>
                                                                    <select
                                                                        name="product[]"
                                                                        className="form-control form-control-user cbo_product"
                                                                        placeholder="Select product"
                                                                        value={oi_items.oi_prod}
                                                                        style={{ padding: "0px 0px 0px 5px" }}
                                                                        onChange={(v) => {
                                                                            let obj = v.target.value
                                                                            obj = JSON.parse(obj)
                                                                            getProdPromotions(obj.p_id, index);
                                                                            let arr = oi_items;
                                                                            arr[index].p_id = obj.p_id
                                                                            arr[index].oi_unit_price = obj.p_MSRP
                                                                            arr[index].prom_apply = false
                                                                            arr[index].oi_prod = obj.p_name
                                                                            arr[index].oi_expiry = obj.p_age
                                                                            // formatOrderExpiry(obj.p_age)
                                                                            // console.log(obj)
                                                                            setOi_items(arr);
                                                                            forceUpdate();
                                                                        }}

                                                                    >
                                                                        {
                                                                            !item.p_id &&
                                                                            <option selected disabled={true}>Select product</option>
                                                                        }
                                                                        {/* <option selected disabled={true}>
                                                                            {item.oi_prod ? item.oi_prod : "Select product"}
                                                                        </option> */}
                                                                        {
                                                                            products.map((v, i) => {
                                                                                return (
                                                                                    <option
                                                                                        // disabled={oi_items[i]?.p_id == v.p_id ? true : false}
                                                                                        // disabled={foundSelectedProducts(v.p_id)}
                                                                                        selected={item.p_id == v.p_id ? true : false}
                                                                                        value={JSON.stringify(v)}
                                                                                    >{v.p_name}</option>
                                                                                )
                                                                            })
                                                                        }

                                                                    </select>
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        className="cbo_quantity form-control form-control-user"
                                                                        // disabled={true}
                                                                        contentEditable={false}
                                                                        placeholder={item.oi_prom_name }
                                                                        value={item.oi_prom_name}
                                                                        style={{ padding: "0px 0px 0px 5px" }}
                                                                    />
                                                                    {/* <br /> */}
                                                                </td>
                                                                <td>
                                                                    <select
                                                                        // name="cust_id"
                                                                        // id="cust_id"
                                                                        className="form-control form-control-user"

                                                                        // value={oi_items.prom_name}
                                                                        onChange={(v) => {
                                                                            if (v.target.value == 'N/A') {
                                                                                // setPromotionsApply(false);
                                                                                let arr = oi_items;
                                                                                arr[index].oi_qty = '';
                                                                                arr[index].oi_amount = '';
                                                                                arr[index].prom_discount = '0';
                                                                                arr[index].oi_prom_id = '';
                                                                                arr[index].oi_prom_name = '';
                                                                                arr[index].oi_discount = '';
                                                                                arr[index].prom_apply = false;
                                                                                setOi_items(arr)
                                                                                forceUpdate();
                                                                            }
                                                                            else {
                                                                                let obj = v.target.value
                                                                                let arr = oi_items;
                                                                                obj = JSON.parse(obj);
                                                                                var makeDiscountString;
                                                                                if (obj.prom_type == 'fixed') {
                                                                                    makeDiscountString = "$" + obj.prom_amount;
                                                                                    arr[index].oi_discount = obj.prom_amount;
                                                                                }
                                                                                else {
                                                                                    makeDiscountString = obj.prom_amount + "%"
                                                                                    let ar = (parseInt(item.oi_unit_price) * parseInt(obj.prom_qty)) - parseInt(obj.prom_price);
                                                                                    arr[index].oi_discount = ar.toString();
                                                                                }


                                                                                arr[index].prom_name = obj.prom_name
                                                                                arr[index].oi_prom_id = obj.prom_id
                                                                                arr[index].oi_prom_name = obj.prom_name
                                                                                arr[index].oi_qty = obj.prom_qty
                                                                                arr[index].oi_amount = obj.prom_price
                                                                                arr[index].prom_discount = makeDiscountString
                                                                                arr[index].prom_apply = true
                                                                                setOi_items(arr)
                                                                                forceUpdate();
                                                                                // setPromotionsApply(true)
                                                                                // setOrderQty(obj.prom_qty);
                                                                                // setOrderPrice(obj.oi_amount);
                                                                                // setPromDiscount(makeDiscountString);
                                                                            }

                                                                        }}
                                                                    >
                                                                        <option value={'N/A'} >
                                                                            N/A
                                                                        </option>
                                                                        {

                                                                            item?.promotions?.map((v, i) => {
                                                                                var is_selected = v.is_selected == '1' ? v.prom_name : null
                                                                                return (
                                                                                    <option
                                                                                        // selected={is_selected}
                                                                                        value={JSON.stringify(v)}>{v.prom_name}</option>
                                                                                )

                                                                            })
                                                                        }

                                                                    </select>

                                                                </td>

                                                                <td>
                                                                    <select
                                                                        className="form-control"
                                                                        placeholder="OD/OS"
                                                                        // disabled={cust_id ? false : true}
                                                                        style={{ padding: "0px 0px 0px 5px" }}
                                                                        onChange={(v) => {
                                                                            let arr = oi_items;
                                                                            arr[index].oi_odos = v.target.value;
                                                                            setOi_items(arr)
                                                                            forceUpdate();
                                                                        }}
                                                                    >
                                                                        <option selected disabled={true}>Select</option>
                                                                        <option selected={item.oi_odos == 'od' ? true : false} value="od">OD</option>
                                                                        <option selected={item.oi_odos == 'os' ? true : false} value="os">OS</option>
                                                                    </select>
                                                                </td>

                                                                <td>
                                                                    <input
                                                                        className="cbo_quantity form-control form-control-user"
                                                                        disabled={true}
                                                                        placeholder={item.oi_unit_price}
                                                                        value={item.oi_unit_price}
                                                                        style={{ width: 50, padding: "0px 0px 0px 5px" }}
                                                                    ></input>
                                                                    <br />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        className="cbo_quantity form-control form-control-user"
                                                                        disabled={item.prom_apply || !item.oi_prod && true || item.oi_prom_id == 0 && false || item.oi_prom_id == '' && false}
                                                                        // disabled={item.prom_apply || !item.oi_prod && true || item?.promotions?.length || item.oi_prom_id  &&  item.oi_prom_id !='0' && true}
                                                                        placeholder={item.oi_qty ? item.oi_qty : "0"}
                                                                        value={item.oi_qty}
                                                                        onChange={(v) => {
                                                                            // console.log()
                                                                            let arr = oi_items;
                                                                            arr[index].oi_qty = v.target.value;
                                                                            arr[index].oi_discount = 0;
                                                                            arr[index].oi_amount = v.target.value * item.oi_unit_price;
                                                                            setOi_items(arr);
                                                                            forceUpdate();
                                                                        }}
                                                                        style={{ width: 50, padding: "0px 0px 0px 5px" }}
                                                                    ></input>
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        className="cbo_quantity form-control form-control-user"
                                                                        disabled={true}
                                                                        value={item.oi_unit_price * item.oi_qty}
                                                                        style={{ width: 50, padding: "0px 0px 0px 5px" }}
                                                                    ></input>
                                                                </td>
                                                                <td>
                                                                    {/* { */}
                                                                    {/* item.prom_discount ? */}
                                                                    <input
                                                                        className="cbo_quantity form-control form-control-user"
                                                                        style={{ width: 50, padding: "0px 0px 0px 5px" }}
                                                                        disabled={true}
                                                                        value={item?.oi_discount ? item.oi_discount : '0'}
                                                                        placeholder={item.oi_discount ? item.oi_discount : '0'}
                                                                    // value={item?.oi_discount ? item.prom_discount : "0"}
                                                                    // placeholder={item.prom_discount ? item.prom_discount : "0"}
                                                                    />
                                                                    {/* //         :
                                                                    //         item?.promotions?.map((v, i) => {
                                                                    //             // var is_selected = v.is_selected == '1' ? true : null
                                                                    //             if (v.is_selected == '1') {
                                                                    //                 return <input
                                                                    //                     className="cbo_quantity form-control form-control-user"
                                                                    //                     style={{ width: 50, padding: "0px 0px 0px 5px" }}
                                                                    //                     disabled={true}
                                                                    //                     value={v.prom_amount}
                                                                    //                     placeholder={v.prom_amount}
                                                                    //                 ></input>
                                                                    //             }
                                                                    //             else return "0"


                                                                    //         })
                                                                    // } */}

                                                                </td>
                                                                <td >
                                                                    <input
                                                                        className="cbo_quantity form-control form-control-user"
                                                                        // disabled={item.oi_prom_id && item.oi_prom_id != '0' ? true : false}
                                                                        disabled={item.prom_apply || !item.oi_prod && true || item.oi_prom_id == 0 && false || item.oi_prom_id == '' && false}
                                                                        placeholder={item.oi_amount ? item.oi_amount : "0"}
                                                                        value={item.oi_amount}
                                                                        onChange={(v) => {
                                                                            let arr = oi_items;
                                                                            arr[index].oi_amount = v.target.value
                                                                            setOi_items(arr)
                                                                            forceUpdate();
                                                                        }}
                                                                        style={{ width: 50, padding: "0px 0px 0px 5px" }}
                                                                    ></input>
                                                                </td>
                                                                {
                                                                    // index > 0 && index == oi_items.length - 1 ?
                                                                    oi_items.length > 1 ?
                                                                        oi_items[index + 1]?.p_id == '' && index == 0 ? null :
                                                                            <td>
                                                                                <Button
                                                                                    onClick={() => {
                                                                                        if (item.oi_id) {
                                                                                            setDelId(item.oi_id)
                                                                                            setDelModal(true)
                                                                                        }
                                                                                        else {
                                                                                            let arr = oi_items;
                                                                                            arr.splice(index, 1);
                                                                                            setOi_items(arr);
                                                                                            forceUpdate()
                                                                                        }


                                                                                    }}
                                                                                    className="btn btn-danger">
                                                                                    <FaTrash color="white" />
                                                                                </Button>

                                                                            </td>
                                                                        : null}
                                                            </tr>

                                                        )
                                                    })
                                                }

                                            </tbody>
                                        </table>
                                        <div className="row mt-4" style={{ textAlign: 'right', marginRight: 50 }} >
                                            <h4 className="h5 mb-2 text-gray-800" style={{ fontFamily: 'PMe' }} >Order Total: {getOrderTotal()}</h4>

                                        </div>
                                        <div style={{ textAlign: "center" }}>
                                            <button
                                                onClick={() => validateOrder()}
                                                className="btn" style={{ backgroundColor: AppColors.primary, color: 'white', fontFamily: 'RBo' }} >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* /.container-fluid */}
                        {/* End of Main Content */}
                        {/* End of Content Wrapper */}
                        {/* End of Page Wrapper */}
                        {/* Scroll to Top Button*/}
                        <a className="scroll-to-top rounded" href="#page-top">
                            <i className="fas fa-angle-up" />
                        </a>
                        {/* Logout Modal*/}
                        <div
                            className="modal fade"
                            id="logoutModal"
                            tabIndex={-1}
                            role="dialog"
                            aria-labelledby="exampleModalLabel"
                            aria-hidden="true"
                        >
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="exampleModalLabel">
                                            Ready to Leave?
                                        </h5>
                                        <button
                                            className="close"
                                            type="button"
                                            data-dismiss="modal"
                                            aria-label="Close"
                                        >
                                            <span aria-hidden="true">×</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        Select "Logout" below if you are ready to end your current session.
                                    </div>
                                    <div className="modal-footer">
                                        <button
                                            className="btn btn-secondary"
                                            type="button"
                                            data-dismiss="modal"
                                        >
                                            Cancel
                                        </button>
                                        <a className="btn btn-primary" href="logout.php">
                                            Logout
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default EditOrder



 // "o_items": [
            //     {
            //         "p_id": "6",
            //         "oi_prod": "test product02",
            //         "oi_odos": "od",
            //         "oi_sph": "test1",
            //         "oi_cyl": "1",
            //         "oi_axis": "1",
            //         "oi_prism": "0",
            //         "oi_fi": "0",
            //         "oi_ct": "0",
            //         "oi_expiry": "2021/11/29",
            //         "oi_unit_price": "1251",
            //         "oi_qty": "2",
            //         "oi_amount": "2440"
            //     }
            // ]